const baseUri = 'cart-items';

export default {
  store(data) {
    return api.post(`${baseUri}`, data);
  },

  update(id, data) {
    return api.patch(`${baseUri}/${id}`, data);
  },

  remove(id) {
    return api.delete(`${baseUri}/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/cartItem.js